
let initialState = {
    portalUser: {
        operators: []
    }
};
  
function user(state = initialState, action) {
    switch(action.type) {
        case 'SET_USER':
            return action.payload;
        default:
            return state;
    }
}
  
export default user;



// WEBPACK FOOTER //
// ./src/reducers/user.js